import React from 'react';
import { ArrowLeft } from 'lucide-react';
export function TermsOfService() {
  return <div className="min-h-screen bg-white" data-id="element-215">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/80 backdrop-blur-md border-b border-slate-800" data-id="element-216">
        <div className="container mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-217">
          <a href="#" className="flex items-center space-x-2 text-white hover:text-cyan-400 transition-colors" data-id="element-218">
            <ArrowLeft className="w-5 h-5" data-id="element-219" />
            <span className="font-medium" data-id="element-220">Back to Home</span>
          </a>
        </div>
      </nav>

      <main className="pt-24 pb-16" data-id="element-221">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-222">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-223">
            Terms of Service
          </h1>
          <p className="text-slate-600 mb-12" data-id="element-224">Last updated: January 1, 2026</p>

          <div className="prose prose-slate max-w-none" data-id="element-225">
            <section className="mb-8" data-id="element-226">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-227">
                1. Acceptance of Terms
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-228">
                By accessing or using Remote Systems' services, you agree to be
                bound by these Terms of Service and all applicable laws and
                regulations. If you do not agree with any of these terms, you
                are prohibited from using or accessing our services.
              </p>
            </section>

            <section className="mb-8" data-id="element-229">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-230">
                2. Use License
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-231">
                Permission is granted to temporarily access and use our services
                for personal, non-commercial use only. This license does not
                include:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2" data-id="element-232">
                <li data-id="element-233">Modifying or copying our materials</li>
                <li data-id="element-234">Using the materials for commercial purposes</li>
                <li data-id="element-235">Attempting to reverse engineer any software</li>
                <li data-id="element-236">Removing copyright or proprietary notations</li>
                <li data-id="element-237">Transferring materials to another person or server</li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-238">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-239">
                3. User Accounts
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-240">
                When you create an account with us, you must provide accurate,
                complete, and current information. You are responsible for:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2" data-id="element-241">
                <li data-id="element-242">
                  Maintaining the confidentiality of your account credentials
                </li>
                <li data-id="element-243">All activities that occur under your account</li>
                <li data-id="element-244">Notifying us immediately of any unauthorized use</li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-245">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-246">
                4. Prohibited Activities
              </h2>
              <p className="text-slate-600 leading-relaxed mb-4" data-id="element-247">
                You agree not to:
              </p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2" data-id="element-248">
                <li data-id="element-249">Violate any applicable laws or regulations</li>
                <li data-id="element-250">Infringe upon intellectual property rights</li>
                <li data-id="element-251">Transmit harmful code, viruses, or malware</li>
                <li data-id="element-252">Engage in unauthorized access or data mining</li>
                <li data-id="element-253">Harass, abuse, or harm other users</li>
                <li data-id="element-254">Impersonate others or provide false information</li>
                <li data-id="element-255">Interfere with the proper functioning of our services</li>
              </ul>
            </section>

            <section className="mb-8" data-id="element-256">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-257">
                5. Intellectual Property
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-258">
                All content, features, and functionality of our services,
                including but not limited to text, graphics, logos, and
                software, are owned by Remote Systems and protected by
                copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section className="mb-8" data-id="element-259">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-260">
                6. Disclaimer of Warranties
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-261">
                Our services are provided "as is" and "as available" without
                warranties of any kind, either express or implied. We do not
                warrant that our services will be uninterrupted, secure, or
                error-free, or that defects will be corrected.
              </p>
            </section>

            <section className="mb-8" data-id="element-262">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-263">
                7. Limitation of Liability
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-264">
                To the maximum extent permitted by law, Remote Systems shall not
                be liable for any indirect, incidental, special, consequential,
                or punitive damages, or any loss of profits or revenues, whether
                incurred directly or indirectly, or any loss of data, use,
                goodwill, or other intangible losses.
              </p>
            </section>

            <section className="mb-8" data-id="element-265">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-266">
                8. Indemnification
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-267">
                You agree to indemnify and hold harmless Remote Systems and its
                officers, directors, employees, and agents from any claims,
                damages, losses, liabilities, and expenses arising out of your
                use of our services or violation of these Terms.
              </p>
            </section>

            <section className="mb-8" data-id="element-268">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-269">
                9. Termination
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-270">
                We may terminate or suspend your account and access to our
                services immediately, without prior notice, for any reason,
                including breach of these Terms. Upon termination, your right to
                use our services will immediately cease.
              </p>
            </section>

            <section className="mb-8" data-id="element-271">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-272">
                10. Changes to Terms
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-273">
                We reserve the right to modify these Terms at any time. We will
                notify users of any material changes by posting the new Terms on
                this page and updating the "Last updated" date. Your continued
                use of our services after changes constitutes acceptance of the
                new Terms.
              </p>
            </section>

            <section className="mb-8" data-id="element-274">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-275">
                11. Governing Law
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-276">
                These Terms shall be governed by and construed in accordance
                with the laws of the jurisdiction in which Remote Systems
                operates, without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="mb-8" data-id="element-277">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-278">
                12. Contact Information
              </h2>
              <p className="text-slate-600 leading-relaxed" data-id="element-279">
                If you have any questions about these Terms of Service, please
                contact us at info@remotesystems.xyz
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>;
}